"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainPipeLinker = void 0;
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const pipeNode_1 = require("./pipeNode");
const boundingBox_1 = require("../boundingBox");
const pipeCommonUtil_1 = require("./util/pipeCommonUtil");
const nodeReverser_1 = require("./warehouse/nodeReverser");
const roomPipeInfo_1 = require("./roomPipeInfo");
class MainPipeLinker {
    linkForNormalRoom(pipeNodeGroups, mainPipes, mainPipesLink, mainPipeNodes, otherRoomPipeInfos, polygon) {
        let roomPipeInfos = [];
        for (let pipeNodeGroup of pipeNodeGroups) {
            let firstMainNode = pipeNodeGroup._mainPipeNodes[0];
            let startNode;
            if (pipeNodeGroup._mainPipeNodes.length == 1) {
                if (firstMainNode._children.length == 1)
                    startNode = firstMainNode;
                else {
                    //用所有主管线的包围盒的中心点来决定往哪边延申
                    let boundingBox = new boundingBox_1.BoundingBox();
                    for (let pipe of mainPipes) {
                        boundingBox.expand(pipe.p0);
                        boundingBox.expand(pipe.p1);
                    }
                    let center = boundingBox.getCenter();
                    const expandDis = 600;
                    //两个方向的延申向量
                    let expandVec1 = new Vector2D_js_1.default(firstMainNode._point, firstMainNode._children[0]._point).normalize().multiply(expandDis).rotate(Math.PI / 2);
                    let expandVec2 = expandVec1.rotate(Math.PI);
                    let vec_mainNodeToCenter = new Vector2D_js_1.default(firstMainNode._point, new Coordinate_js_1.default(center.x, center.y));
                    //选夹角绝对值小于90°的
                    if (Math.abs(vec_mainNodeToCenter.angleTo(expandVec1)) < Math.PI / 2) {
                        startNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(firstMainNode._point.x + expandVec1.getX(), firstMainNode._point.y + expandVec1.getY()), pipeNode_1.PipeNodeType.Main);
                    }
                    else {
                        startNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(firstMainNode._point.x + expandVec2.getX(), firstMainNode._point.y + expandVec2.getY()), pipeNode_1.PipeNodeType.Main);
                    }
                    startNode.addChildNode(firstMainNode);
                }
            }
            else {
                //延申600距离
                const expandDis = 600;
                let secondMainNode = pipeNodeGroup._mainPipeNodes[1];
                let expandVec = new Vector2D_js_1.default(secondMainNode._point, firstMainNode._point).normalize().multiply(expandDis);
                startNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(firstMainNode._point.x + expandVec.getX(), firstMainNode._point.y + expandVec.getY()), pipeNode_1.PipeNodeType.Main);
                startNode.addChildNode(firstMainNode);
            }
            //按与顶点的距离排序
            let sortedMainPipes = mainPipes.concat();
            sortedMainPipes.sort(function (a, b) { return a.distance(startNode._point) - b.distance(startNode._point); });
            //从距离较小的几段线里面计算（TODO：这里有重复计算，待优化）
            let minDis = sortedMainPipes[0].distance(startNode._point);
            let computeMainPipes = new Array();
            computeMainPipes.push(sortedMainPipes[0]);
            for (let i = 1; i < sortedMainPipes.length; i++) {
                let pipe = sortedMainPipes[i];
                if (pipe.distance(startNode._point) - minDis < 1e-4) {
                    computeMainPipes.push(pipe);
                }
            }
            //TODO：这里也存在重复计算，待优化
            computeMainPipes.sort(function (a, b) { return a.distancePerpendicular(startNode._point) - b.distancePerpendicular(startNode._point); });
            let targetMainPipe = computeMainPipes[0];
            let projectionFactor = targetMainPipe.projectionFactor(startNode._point);
            let projectionPoint = targetMainPipe.pointAlong(projectionFactor);
            let nearMainPipeLink;
            for (let pipe of mainPipesLink) {
                if (this.isTwoSegmentNear(pipe, new LineSegment_js_1.default(projectionPoint, startNode._point))) {
                    nearMainPipeLink = pipe;
                    break;
                }
            }
            if (nearMainPipeLink) {
                projectionFactor = nearMainPipeLink.projectionFactor(startNode._point);
                projectionPoint = nearMainPipeLink.pointAlong(projectionFactor);
                targetMainPipe = nearMainPipeLink;
            }
            //判断连接线是否穿过其他房间
            let otherRoom;
            for (let roomPipeInfo of otherRoomPipeInfos) {
                if (roomPipeInfo.IsPassThroughThisRoom(startNode._point, projectionPoint)) {
                    otherRoom = roomPipeInfo;
                    break;
                }
                if (roomPipeInfo.IsPassThroughThisRoom(projectionPoint, targetMainPipe.p0)) {
                    otherRoom = roomPipeInfo;
                    break;
                }
            }
            if (otherRoom) {
                let otherRoomMainPipes = otherRoom.getMainPipes();
                if (otherRoomMainPipes.length > 0) {
                    otherRoomMainPipes.sort(function (a, b) { return a.distance(startNode._point) - b.distance(startNode._point); });
                    projectionFactor = otherRoomMainPipes[0].projectionFactor(startNode._point);
                    projectionPoint = otherRoomMainPipes[0].pointAlong(projectionFactor);
                    targetMainPipe = otherRoomMainPipes[0];
                }
                else { //穿过的房间只有一个主管点的情况，暂不处理
                    otherRoom = undefined;
                }
            }
            //判断投影的线是否与原来的管线重叠
            if (pipeNodeGroup._mainPipeNodes.length == 1) {
                if (startNode._children.length == 1) { //这里仅处理了连接其他房间的主干管造成的重叠
                    let child = startNode._children[0];
                    //区分是单个子节点和多个子节点的情况。仅处理多个子节点的情况
                    if (child._children.length > 1) {
                        //如果mainPipeNodes[0]比startNode更靠近projectionPoint，则表明延申错了方向。需要进行调转
                        if (pipeNodeGroup._mainPipeNodes[0]._point.distance(startNode._point) < projectionPoint.distance(startNode._point)) {
                            //再判断是否与本身的管线重合
                            let childPipes = new Array();
                            pipeCommonUtil_1.PipeCommonUtil.traverseToGetChildPipes(pipeNodeGroup._mainPipeNodes[0], childPipes);
                            let isOverlap = false;
                            let seg_startNodeToProjectPoint = new LineSegment_js_1.default(startNode._point, projectionPoint);
                            for (let childPipe of childPipes) {
                                if (seg_startNodeToProjectPoint.intersection(childPipe)) {
                                    isOverlap = true;
                                    break;
                                }
                            }
                            if (isOverlap) {
                                //startNode偏移到距离child._point为1的地方，方向为child._point->projectionPoint。效果相当于翻转延长线方向。由于这两节线段在同一直线上，所以在sprayMain文件中会将startNode化简掉。
                                let offsetVec = new Vector2D_js_1.default(child._point, projectionPoint).normalize();
                                startNode._point.x = child._point.x + offsetVec.getX();
                                startNode._point.y = child._point.y + offsetVec.getY();
                            }
                        }
                    }
                }
            }
            else { //处理投影点与房间自身的主管线重叠的情况
                startNode.removeChildNode(firstMainNode);
                let handledStartNode = this.handleOverlap(firstMainNode, projectionPoint, pipeNodeGroup._mainPipeNodes);
                if (handledStartNode) {
                    startNode.addChildNode(handledStartNode);
                }
                else {
                    startNode.addChildNode(firstMainNode);
                }
            }
            mainPipeNodes.push(startNode);
            //如果是要连接到别的房间，则需要替换掉mainPipeNodes，因为mainPipeNodes里找不到对应的节点
            //而mainPipes也要替换掉，否则会影响其他房间的结果
            //与外部共用的mainPipeNodes数组
            //otherRoom为False时，两个数组为同一个数组
            let commonMainPipeNodes = mainPipeNodes;
            if (otherRoom) {
                nearMainPipeLink = undefined;
                mainPipes = [];
                mainPipeNodes = otherRoom.getMainPipeNodes();
            }
            //判断投影点在不在原来的直线上
            if (projectionFactor == 0.0) {
                let node = this.findNode(targetMainPipe.p0, mainPipeNodes);
                node.addChildNode(startNode);
                mainPipesLink.push(new LineSegment_js_1.default(targetMainPipe.p0, startNode._point));
            }
            else if (projectionFactor == 1.0) {
                let node = this.findNode(targetMainPipe.p1, mainPipeNodes);
                node.addChildNode(startNode);
                mainPipesLink.push(new LineSegment_js_1.default(targetMainPipe.p1, startNode._point));
            }
            else if (projectionFactor < 0.0) {
                let newMainPipe = new LineSegment_js_1.default(projectionPoint, targetMainPipe.p0);
                if (nearMainPipeLink) {
                    mainPipesLink.push(newMainPipe);
                }
                else {
                    mainPipes.push(newMainPipe);
                }
                let node_p0 = this.findNode(targetMainPipe.p0, mainPipeNodes);
                if (projectionPoint.equals2D(startNode._point)) {
                    node_p0.addChildNode(startNode);
                    mainPipesLink.push(new LineSegment_js_1.default(node_p0._point, startNode._point));
                }
                else {
                    //新建节点
                    let projectNode = new pipeNode_1.PipeNode(projectionPoint, pipeNode_1.PipeNodeType.Main);
                    node_p0.addChildNode(projectNode);
                    projectNode.addChildNode(startNode);
                    commonMainPipeNodes.push(projectNode);
                    mainPipesLink.push(new LineSegment_js_1.default(projectionPoint, startNode._point));
                }
            }
            else if (projectionFactor > 1.0) {
                let newMainPipe = new LineSegment_js_1.default(targetMainPipe.p1, projectionPoint);
                if (nearMainPipeLink) {
                    mainPipesLink.push(newMainPipe);
                }
                else {
                    mainPipes.push(newMainPipe);
                }
                let node_p1 = this.findNode(targetMainPipe.p1, mainPipeNodes);
                if (projectionPoint.equals2D(startNode._point)) {
                    node_p1.addChildNode(startNode);
                    mainPipesLink.push(new LineSegment_js_1.default(node_p1._point, startNode._point));
                }
                else {
                    //新建节点
                    let projectNode = new pipeNode_1.PipeNode(projectionPoint, pipeNode_1.PipeNodeType.Main);
                    node_p1.addChildNode(projectNode);
                    projectNode.addChildNode(startNode);
                    commonMainPipeNodes.push(projectNode);
                    mainPipesLink.push(new LineSegment_js_1.default(projectionPoint, startNode._point));
                }
            }
            else { //在原来的线段中间
                let newMainPipes = [new LineSegment_js_1.default(targetMainPipe.p0, projectionPoint), new LineSegment_js_1.default(projectionPoint, targetMainPipe.p1)];
                if (nearMainPipeLink) {
                    //移除原来的线段
                    mainPipesLink.splice(mainPipesLink.indexOf(targetMainPipe), 1);
                    //插入新的线段
                    mainPipesLink.push(newMainPipes[0]);
                    mainPipesLink.push(newMainPipes[1]);
                }
                else {
                    //移除原来的线段
                    mainPipes.splice(mainPipes.indexOf(targetMainPipe), 1);
                    //插入新的线段
                    mainPipes.push(newMainPipes[0]);
                    mainPipes.push(newMainPipes[1]);
                }
                //判断p0和p1两个节点的父子关系
                let node_p0 = this.findNode(targetMainPipe.p0, mainPipeNodes);
                let node_p1 = this.findNode(targetMainPipe.p1, mainPipeNodes);
                if (node_p1._parent == node_p0) {
                    node_p0._children.splice(node_p0._children.indexOf(node_p1), 1);
                    //新建并插入节点
                    if (projectionPoint.equals2D(startNode._point)) {
                        node_p0.addChildNode(startNode);
                        startNode.addChildNode(node_p1);
                    }
                    else {
                        let projectNode = new pipeNode_1.PipeNode(projectionPoint, pipeNode_1.PipeNodeType.Main);
                        node_p0.addChildNode(projectNode);
                        projectNode.addChildNode(node_p1);
                        projectNode.addChildNode(startNode);
                        commonMainPipeNodes.push(projectNode);
                        mainPipesLink.push(new LineSegment_js_1.default(projectionPoint, startNode._point));
                    }
                }
                else if (node_p0._parent == node_p1) {
                    node_p1._children.splice(node_p1._children.indexOf(node_p0), 1);
                    //新建并插入节点
                    if (projectionPoint.equals2D(startNode._point)) {
                        node_p1.addChildNode(startNode);
                        startNode.addChildNode(node_p0);
                    }
                    else {
                        let projectNode = new pipeNode_1.PipeNode(projectionPoint, pipeNode_1.PipeNodeType.Main);
                        node_p1.addChildNode(projectNode);
                        projectNode.addChildNode(node_p0);
                        projectNode.addChildNode(startNode);
                        commonMainPipeNodes.push(projectNode);
                        mainPipesLink.push(new LineSegment_js_1.default(projectionPoint, startNode._point));
                    }
                }
                else {
                    console.log(node_p0);
                    console.log(node_p1);
                    debugger;
                    throw new Error("p0和p1不是父子关系");
                }
            }
            roomPipeInfos.push(new roomPipeInfo_1.RoomPipeInfo(startNode, pipeNodeGroups));
        }
        return roomPipeInfos;
    }
    handleOverlap(firstMainNode, projectionPoint, mainPipeNodesInGroup) {
        let roomMainPipes = new Array();
        pipeCommonUtil_1.PipeCommonUtil.traverseToGetMainPipes(firstMainNode, roomMainPipes);
        let closestSegment;
        for (let pipe of roomMainPipes) {
            if (pipe.distance(projectionPoint) < 0.1) {
                closestSegment = pipe;
                break;
            }
        }
        if (closestSegment === undefined)
            return null;
        let node_p0 = this.findNode(closestSegment.p0, mainPipeNodesInGroup);
        let node_p1 = this.findNode(closestSegment.p1, mainPipeNodesInGroup);
        let parent;
        let child;
        if (node_p1._parent == node_p0) {
            parent = node_p0;
            child = node_p1;
        }
        else if (node_p0._parent == node_p1) {
            parent = node_p1;
            child = node_p0;
        }
        else {
            console.error("p0和p1不是父子关系");
            return null;
        }
        //父节点那端需要翻转顺序
        let rootNode = parent.getRootNode();
        let reverseRootNode = new nodeReverser_1.NodeReverser().executeForNormalRoom(rootNode);
        return reverseRootNode;
    }
    findNode(point, nodes) {
        for (let node of nodes) {
            if (node._point.equals2D(point)) {
                return node;
            }
        }
        debugger;
        throw new Error("连接主管道时没有找到节点");
    }
    //判断是否有比较近的其他房间的连接线
    isTwoSegmentNear(seg1, seg2) {
        const nearThreshold = 1000;
        if (seg1.distance(seg2.p0) < nearThreshold && seg1.distance(seg2.p1) < nearThreshold) {
            return true;
        }
        else if (seg2.distance(seg1.p0) < nearThreshold && seg2.distance(seg1.p1) < nearThreshold) {
            return true;
        }
        return false;
    }
}
exports.MainPipeLinker = MainPipeLinker;
